import type {RecordRow} from 'src/features/record-grid/lib/types';

export const logbookReportsPageSize = 100;
export type LogbookReportPairingType = 'pair' | 'unpair';

export interface PairUnpairEventData {
    record: RecordRow;
    pairingType: LogbookReportPairingType;
}